<div class="py-4 px-8 bg-gray-200 min-h-screen w-full overflow-x-hidden">
  
  <!-- products section -->
  <div class="rounded-lg">

    <!-- products section header with edit button -->
    <div class="flex items-center justify-between bg-[#00358E] py-3 px-8 border-top-section">
      <p class="text-white font-semibold">Products</p>
      <button (click)="toggleProductModal()" [disabled]="isLoading() || !hasClientData()" class="bg-white text-[#00358E] px-4 py-2 rounded-full font-semibold flex items-center gap-2 disabled:opacity-60 disabled:cursor-not-allowed">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"></path>
        </svg>
        Edit Product
      </button>
    </div>

    <!-- products section content -->
    <div class="bg-white py-6 px-12 border-bottom-section">
      <!-- Column headers -->
      <div class="grid grid-cols-[220px_1fr] gap-x-8 gap-y-5">
        <p class="text-[#00358E] font-bold text-sm">Product Group</p>
        <p class="text-[#00358E] font-bold text-sm">Products</p>

        <!-- Product group rows -->
        <ng-container *ngFor="let group of clientData().productGroups">
          <!-- Product Group Badge -->
          <div class="flex items-center">
            <span class="inline-block bg-[#3A79C7] text-white text-xs font-semibold px-4 py-2 rounded-full whitespace-nowrap">
              {{ group.groupName }}
            </span>
          </div>
          <!-- Products Badges -->
          <div class="flex flex-wrap items-center gap-2">
            <span *ngFor="let product of group.products"
              class="inline-flex items-center border-[#1D65BE] border-[1px] text-[#00358E] text-xs font-semibold px-4 py-2 rounded-full bg-white whitespace-nowrap gap-2">
              {{ product.productName }}
              <span *ngIf="product.productStatus"
                class="inline-flex items-center text-[10px] font-medium rounded-full px-2 py-0.5 border"
                [ngClass]="getStatusClass(product.productStatus)">
                <span class="status-dot w-1.5 h-1.5 rounded-full mr-1"></span>
                {{ product.productStatus }}
              </span>
            </span>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="border-b border-b-white border-rounded-s mt-7 border-top-section border-gray-200 bg-[#00358E] h-16">
    <div class="flex items-center w-full h-full">
      <div class="flex-1 flex ml-14 justify-start h-full items-center">
        <nav class="flex space-x-8 h-full items-center">
          <button
            *ngFor="let tab of visibleTabs()"
            class="relative py-2 px-1 text-base text-white font-medium cursor-pointer"
            [ngClass]="{
              'text-white': activeTab() === tab.tabKey,
              'text-gray-300 hover:text-white': activeTab() !== tab.tabKey
            }"
            (click)="setActiveTab(tab.tabKey)"
          >
            <span class="relative inline-block">
              {{ tab.formTitle }}
              <span
                *ngIf="activeTab() === tab.tabKey"
                class="absolute -bottom-2 left-0 w-full h-[3px] mt-2 bg-white rounded-[2px]"
              ></span>
            </span>
          </button>
        </nav>
      </div>

      <div class="flex gap-2 mr-4 h-full items-center">
        <ng-container *ngIf="!anySectionEditing(); else globalEditingButtons">
          <button
            type="button"
            (click)="startAllSectionsEdit()"
            class="px-4 py-2 rounded-full font-semibold flex items-center gap-2 bg-white text-[#00358E] text-sm disabled:opacity-60 disabled:cursor-not-allowed"
            [disabled]="isLoading() || disableEditButton()"
          >
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"></path>
        </svg>
          
            Edit Information 
          </button>
        </ng-container>
        <ng-template #globalEditingButtons>
          <button
            type="button"
            (click)="cancelAllSectionsEdit()"
            class="px-4 py-1.5 bg-white text-[#00358E] rounded-full text-sm font-semibold disabled:opacity-60 disabled:cursor-not-allowed"
            [disabled]="isLoading()"
          >
            Cancel
          </button>
           <button
            type="button"
            (click)="saveAllSections()"
            class="px-4 py-1.5 bg-white text-[#00358E] rounded-full text-sm font-semibold disabled:opacity-60 disabled:cursor-not-allowed"
            [disabled]="isLoading()"
          >
            Save
          </button>
        </ng-template>
      </div>
      
      <!-- Export Data Button -->
      <!-- <div class="flex items-center">
        <button 
          (click)="exportClientData()" 
          [disabled]="isExporting || !hasClientData()"
          class="px-4 py-1.5 mr-2 rounded-lg text-white flex items-center gap-2 transition-colors disabled:opacity-60 disabled:cursor-not-allowed
                 {{ (isExporting || !hasClientData()) ? 'bg-green-400' : 'bg-green-500 hover:bg-green-600' }}">
          <ng-container *ngIf="!isExporting; else exportingTpl">Export</ng-container>
          <ng-template #exportingTpl>
            <span class="flex items-center gap-2">
              <span class="inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
              Exporting...
            </span>
          </ng-template>
        </button>
      </div> -->
      <!-- Global edit controls removed; per-section controls added inside each section -->
    </div>
  </div>
  <div class="flex w-full">

    <div class="flex-1 min-w-0">
      <div class="bg-white rounded-b-[8px] shadow-md">
        <div>
        <section *ngFor="let section of sections; let first = first" class="section-card dropdown-visible-card  relative w-full max-w-full px-11 py-6" [ngClass]="{'table-card': section.type === 'table'}" [style.zIndex]="hasOpenDropdownInSection(section) ? 100 : (section.isOnEditMode ? 50 : 1)" [style.overflow]="'visible'">
          <div *ngIf="!first" class="border-t border-gray-200 -mt-6 mb-6"></div>
          <div
            class="flex justify-start items-center cursor-pointer"
            (click)="toggleSection(section, section.collapsible)"
          >
            <ng-container *ngIf="section.collapsible">
              <span class="ml-2 mb-2 flex items-center justify-center w-6 h-6">
                <lucide-icon
                  *ngIf="section.collapsible"
                  name="chevron-right"
                  class="transition-transform duration-300 text-[#00358E]"
                  [class.rotate-90]="!section.collapsed"
                ></lucide-icon>
              </span>
            </ng-container>
            <h4 class="card-title" [class.pl-2]="section.collapsible">
              {{ section.title }}
            </h4>
          </div>

          <!-- Collapsible content -->
          <form #f="ngForm" (ngSubmit)="onSubmitSection(section, f)" class="transition-all duration-300 ease-in-out" [style.maxHeight]="section.collapsed ? '0px' : 'fit-content'" [style.overflow]="section.collapsed ? 'hidden' : 'visible'" novalidate>
            <ng-container *ngIf="section.type !== 'table'; else tableSection">
              <div class="grid gap-4 mt-2 grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 px-3 pl-5">
                <div *ngFor="let field of section.fields" class="card-header min-w-0">
                  <!-- Show top label only when not editing an editable field; in edit mode every field uses its own inline label -->
                  <label *ngIf="!section.isOnEditMode || !field.editable" class="text-black font-medium text-sm">
                    {{ field.label }} <span *ngIf="isFieldRequired(field)" class="text-red-500">*</span>
                  </label>
                  <ng-container *ngIf="!section.isOnEditMode || !field.editable; else editField">
                    <p class="font-light break-words">{{ getClientFieldValue(field.key) || field.default || '' }}</p>
                  </ng-container>
                  <ng-template #editField>
                    <ng-container [ngSwitch]="field.type">
                      <!-- Text -->
                      <div *ngSwitchCase="'text'" class="relative"><input id="{{field.key}}Input" type="text" name="{{field.key}}" #ctrl="ngModel" class="w-full border rounded px-3 py-3 text-sm font-light focus:outline-none focus:ring-2 focus:ring-blue-400" [ngClass]="{'ring-1 ring-red-500 bg-red-50': isFieldInvalid(field)}" [ngModel]="getEditValue(field.key)" (ngModelChange)="setEditValue(field.key, $event)" autocomplete="off"/><label [for]="field.key + 'Input'" class="absolute left-3 cursor-text px-1" [ngClass]="{'-top-2 text-xs text-gray-600 bg-white shadow-sm': getEditValue(field.key),'top-3 text-sm text-gray-500 bg-transparent': !getEditValue(field.key)}">
                          {{ field.label }} <span *ngIf="isFieldRequired(field)" class="text-red-500">*</span></label></div>
                      <!-- Email -->
                      <div *ngSwitchCase="'email'" class="relative"><input id="{{field.key}}Input"
                          type="email" name="{{field.key}}" #ctrl="ngModel" class="w-full border rounded px-3 py-3 text-sm font-light focus:outline-none focus:ring-2 focus:ring-blue-400" [ngClass]="{'ring-1 ring-red-500 bg-red-50': isFieldInvalid(field)}" [ngModel]="getEditValue(field.key)" (ngModelChange)="setEditValue(field.key, $event)" autocomplete="off"/><label
                          [for]="field.key + 'Input'"
                          class="absolute left-3 cursor-text px-1"
                          [ngClass]="{
                            '-top-2 text-xs text-gray-600 bg-white shadow-sm': getEditValue(field.key),
                            'top-3 text-sm text-gray-500 bg-transparent': !getEditValue(field.key)
                          }">{{ field.label }} <span *ngIf="isFieldRequired(field)" class="text-red-500">*</span></label></div>

                      <!-- Date -->
                      <div *ngSwitchCase="'date'" class="relative">
                        <kendo-datepicker
                          [id]="field.key + 'Input'"
                          [value]="getEditDateValue(field.key)"
                          (valueChange)="onDateChange(field.key, $event)"
                          [format]="'MM/dd/yyyy'"
                          [placeholder]="' '"
                          class="w-full custom-kendo-datepicker"
                          [ngClass]="{'ring-1 ring-red-500 bg-red-50 rounded': isFieldInvalid(field)}"
                        ></kendo-datepicker>
                        <label
                          [for]="field.key + 'Input'"
                          class="absolute left-3 cursor-text px-1 pointer-events-none"
                          [ngClass]="{
                            '-top-2 text-xs text-gray-600 bg-white shadow-sm': getEditValue(field.key),
                            'top-3 text-sm text-gray-500 bg-transparent': !getEditValue(field.key)
                          }"
                        >
                          {{ field.label }} <span *ngIf="isFieldRequired(field)" class="text-red-500">*</span>
                        </label>
                      </div>

                      <!-- Select -->
                      <div *ngSwitchCase="'select'" class="relative">
                        <!-- Normal single-select when multi is not true -->
                        <ng-container *ngIf="!field.multi; else multiSelectTpl">
                          <div class="relative" data-dropdown-scope="true">
                            <input
                              id="{{field.key}}Input"
                              type="text"
                              readonly
                              class="w-full border rounded px-3 pr-10 py-3 text-sm font-light focus:outline-none focus:ring-2 focus:ring-blue-400 bg-white cursor-pointer"
                              [ngClass]="{'ring-1 ring-red-500 bg-red-50': isFieldInvalid(field)}"
                              [value]="getEditValue(field.key) || ''"
                              (click)="toggleSingleDropdown(field.key)"
                            />
                            <span class="absolute right-2 top-1/2 -translate-y-1/2 pointer-events-none text-gray-500">
                              <svg class="w-10 h-5" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                                <path d="M7 10h10l-5 6z"></path>
                              </svg>
                            </span>
                            <label
                              [for]="field.key + 'Input'"
                              class="absolute left-3 cursor-text px-1 pointer-events-none"
                              [ngClass]="{
                                '-top-2 text-xs text-gray-600 bg-white shadow-sm': getEditValue(field.key),
                                'top-3 text-sm text-gray-500 bg-transparent': !getEditValue(field.key)
                              }"
                            >
                              {{ field.label }} <span *ngIf="isFieldRequired(field)" class="text-red-500">*</span>
                            </label>

                            <div
                              *ngIf="isSingleDropdownOpen(field.key)"
                              class="absolute mt-1 w-full bg-white border rounded-md shadow-md max-h-48 overflow-auto"
                              style="z-index: 1000;"
                            >
                              <button
                                type="button"
                                *ngFor="let opt of getFieldOptions(field)"
                                (mousedown)="$event.preventDefault(); selectSingleOption(field.key, opt)"
                                class="w-full px-3 py-2 text-sm text-left cursor-pointer select-none hover:bg-blue-50"
                              >
                                {{ opt }}
                              </button>
                            </div>
                          </div>
                        </ng-container>

                        <!-- Multi-select dropdown with checkboxes when field.multi is true -->
                        <ng-template #multiSelectTpl>
                          <div class="relative" data-dropdown-scope="true">
                            <input
                              id="{{field.key}}Input"
                              type="text"
                              readonly
                              class="w-full border rounded px-3 pr-10 py-3 text-sm font-light focus:outline-none focus:ring-2 focus:ring-blue-400 bg-white cursor-pointer"
                              [ngClass]="{'ring-1 ring-red-500 bg-red-50': isFieldInvalid(field)}"
                              [value]="getMultiDisplayValue(field.key)"
                              (click)="toggleMultiDropdown(field.key)"
                            />
                            <span class="absolute right-2 top-1/2 -translate-y-1/2 pointer-events-none text-gray-500">
                              <svg class="w-10 h-5" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                                <path d="M7 10h10l-5 6z"></path>
                              </svg>
                            </span>
                            <label
                              [for]="field.key + 'Input'"
                              class="absolute left-3 cursor-text px-1 pointer-events-none"
                              [ngClass]="{
                                '-top-2 text-xs text-gray-600 bg-white shadow-sm': getEditValue(field.key),
                                'top-3 text-sm text-gray-500 bg-transparent': !getEditValue(field.key)
                              }"
                            >
                              {{ field.label }} <span *ngIf="isFieldRequired(field)" class="text-red-500">*</span>
                            </label>

                            <div
                              *ngIf="isMultiDropdownOpen(field.key)"
                              class="absolute mt-1 w-full bg-white border rounded-md shadow-md max-h-48 overflow-auto"
                              style="z-index: 1000;"
                            >
                              <label
                                *ngFor="let opt of getFieldOptions(field)"
                                class="flex items-center px-3 py-1 text-sm cursor-pointer select-none"
                              >
                                <input
                                  type="checkbox"
                                  class="mr-2"
                                  [checked]="isOptionSelected(field.key, opt)"
                                  (change)="onMultiCheckboxChange(field.key, opt, $event.target.checked)"
                                />
                                <span>{{ opt }}</span>
                              </label>
                            </div>
                          </div>
                        </ng-template>
                      </div>

                      <!-- Textarea (default) -->
                      <div *ngSwitchDefault class="relative">
                        <textarea
                          id="{{field.key}}Input"
                          name="{{field.key}}"
                          #ctrl="ngModel"
                          class="w-full border rounded px-3 py-3 text-sm font-light focus:outline-none focus:ring-2 focus:ring-blue-400"
                          [ngClass]="{'ring-1 ring-red-500 bg-red-50': isFieldInvalid(field)}"
                          [ngModel]="getEditValue(field.key)"
                          (ngModelChange)="setEditValue(field.key, $event)"
                          rows="2"
                        ></textarea>
                        <label
                          [for]="field.key + 'Input'"
                          class="absolute left-3 cursor-text px-1"
                          [ngClass]="{
                            '-top-2 text-xs text-gray-600 bg-white shadow-sm': getEditValue(field.key),
                            'top-3 text-sm text-gray-500 bg-transparent': !getEditValue(field.key)
                          }"
                        >
                          {{ field.label }} <span *ngIf="isFieldRequired(field)" class="text-red-500">*</span>
                        </label>
                      </div>
                    </ng-container>
                  </ng-template>
                </div>
              </div>
            </ng-container>
            <ng-template #tableSection>
              <div class="overflow-visible mt-2 px-0 bg-white rounded-sm">
                <table class="w-full table-auto border-collapse">
                  <thead class="bg-[#4A4A4A] text-white">
                    <tr>
                      <th *ngFor="let field of section.fields" class="px-2 py-3 text-left first:border-l border-b border-r border-[#5E5E5E] last:border-r-0 font-semibold text-sm leading-5 whitespace-normal break-words">
                        {{ field.label }} <span *ngIf="field.required" class="text-red-500">*</span>
                      </th>
                      <th *ngIf="section.isOnEditMode" class="w-12 px-2 py-3 text-center border-b border-r border-[#5E5E5E] font-semibold text-sm leading-5">
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="bg-white" *ngFor="let contact of getTableRowsForSection(section); let i = index; trackBy: trackTableRow">
                      <td *ngFor="let field of section.fields" class="px-2 py-3 border-b first:border-l border-r border-[#D5D5D5] text-sm leading-5 text-[#1F1F1F] align-middle whitespace-normal break-words">
                        <ng-container *ngIf="isFederationProductCell(section, field, contact); else standardContactCell">
                          <div class="relative" data-dropdown-scope="true">
                            <input
                              type="text"
                              readonly
                              name="fedProduct_{{ contact.productId || i }}"
                              class="w-full border rounded px-2 pr-8 py-2 text-sm font-light focus:outline-none focus:ring-2 focus:ring-blue-400 bg-white cursor-pointer"
                              [ngModel]="getContactFieldValue(contact, 'productName')"
                              (click)="onInternalEmailInputFocus(section, federationProductField, i)"
                              (focus)="onInternalEmailInputFocus(section, federationProductField, i)"
                              (blur)="onInternalEmailInputBlur(section, federationProductField, i)"
                            />
                            <button
                              type="button"
                              class="absolute right-2 top-1/2 -translate-y-1/2 text-gray-500"
                              (mousedown)="$event.preventDefault(); toggleInternalEmailDropdownAll(section, federationProductField, i)"
                              aria-label="Show products"
                              title="Show products"
                            >
                              <svg class="w-10 h-5" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                                <path d="M7 10h10l-5 6z"></path>
                              </svg>
                            </button>
                            <div
                              *ngIf="isInternalEmailDropdownOpen(section, federationProductField, i)"
                              class="absolute z-30 top-full left-0 mt-1 w-full bg-white border rounded-md shadow-md"
                              style="max-height: 10rem; overflow-y: auto; overflow-x: hidden; overscroll-behavior: contain;"
                              (wheel)="$event.stopPropagation()"
                            >
                              <button
                                type="button"
                                *ngFor="let opt of getFederationProductOptions(section, i)"
                                (mousedown)="$event.preventDefault(); selectFederationProductOption(section, i, opt.productId)"
                                class="w-full px-3 py-2 text-sm text-left hover:bg-blue-50"
                              >
                                {{ opt.productName }}
                              </button>
                            </div>
                          </div>
                        </ng-container>
                        <ng-template #standardContactCell>
                          <ng-container *ngIf="!section.isOnEditMode || !field.editable; else editContactField">
                            <ng-container *ngIf="field.type === 'textbox'; else plainContactValue">
                              <button
                                *ngIf="getContactFieldValue(contact, field.key); else emptyNotesCell"
                                type="button"
                                (click)="openNotesModal(section, field, i)"
                                class="inline-flex items-center gap-1.5 text-[#00358E] hover:underline max-w-full"
                                title="View notes"
                              >
                                <svg class="w-4 h-4 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                                  <path d="M14 2v6h6"></path>
                                  <path d="M8 13h8"></path>
                                  <path d="M8 17h5"></path>
                                </svg>
                                <span class="truncate max-w-[180px] text-sm">{{ getContactFieldValue(contact, field.key) }}</span>
                              </button>
                              <ng-template #emptyNotesCell><span class="text-gray-400">—</span></ng-template>
                            </ng-container>
                            <ng-template #plainContactValue>
                              {{ getContactFieldValue(contact, field.key) || field.default || '' }}
                            </ng-template>
                          </ng-container>
                        </ng-template>
                        <ng-template #editContactField>
                          <ng-container [ngSwitch]="field.type">
                            <div *ngSwitchCase="'email'" class="w-full">
                              <input
                                type="email"
                                name="{{ tableRowName(section, field.key, contact, i) }}"
                                #c="ngModel"
                                class="w-full bg-transparent border-0 p-0 text-sm leading-5 text-[#1F1F1F] focus:outline-none"
                                [ngClass]="{ 'ring-1 ring-red-500 rounded px-2 py-1 bg-red-50': isTableEmailInvalid(section, field, i) || isTableFieldInvalid(section, field, i) }"
                                [ngModel]="getEditContact(section, i, field.key)"
                                (ngModelChange)="setEditContact(section, i, field.key, $event)"
                                (blur)="onTableInputBlur(section, field, i)"
                                [required]="field.required"
                              />
                              <div *ngIf="isTableEmailInvalid(section, field, i)" class="mt-1 text-xs text-red-600">
                                Invalid email
                              </div>
                            </div>

                            <div *ngSwitchCase="'date'" class="relative">
                              <kendo-datepicker
                                [id]="field.key + '_' + i + 'Input'"
                                [value]="getEditContactDateValue(section, i, field.key)"
                                (valueChange)="onContactDateChange(section, i, field.key, $event)"
                                [format]="'MM/dd/yyyy'"
                                [placeholder]="' '"
                                class="w-full custom-kendo-datepicker"
                                [ngClass]="{'ring-1 ring-red-500 bg-red-50 rounded': isTableFieldInvalid(section, field, i)}"
                              ></kendo-datepicker>
                            </div>

                            <ng-container *ngSwitchCase="'select'">
                              <ng-container *ngIf="!field.multi; else multiTableSelectTpl">
                                <ng-container *ngIf="isInternalContactsEmailField(section, field); else singleTableSelectTpl">
                                  <div class="relative" data-dropdown-scope="true">
                                    <input
                                      type="text"
                                      name="{{ tableRowName(section, field.key, contact, i) }}"
                                      #c="ngModel"
                                      class="w-full border rounded px-2 pr-8 py-2 text-sm font-light focus:outline-none focus:ring-2 focus:ring-blue-400 bg-white"
                                      [ngClass]="{ 'border-red-500 ring-1 ring-red-300 bg-red-50': isTableEmailInvalid(section, field, i) || isTableFieldInvalid(section, field, i) }"
                                      [ngModel]="getEditContact(section, i, field.key)"
                                      (ngModelChange)="onInternalEmailInputChange(section, field, i, $event)"
                                      (click)="onInternalEmailInputFocus(section, field, i)"
                                      (focus)="onInternalEmailInputFocus(section, field, i)"
                                      (blur)="onInternalEmailInputBlur(section, field, i)"
                                      [required]="field.required"
                                    />
                                    <button
                                      type="button"
                                      class="absolute right-2 top-1/2 -translate-y-1/2 text-gray-500"
                                      (mousedown)="$event.preventDefault(); toggleInternalEmailDropdownAll(section, field, i)"
                                      aria-label="Show emails"
                                      title="Show emails"
                                    >
                                      <svg class="w-10 h-5" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                                        <path d="M7 10h10l-5 6z"></path>
                                      </svg>
                                    </button>

                                    <div
                                      *ngIf="isInternalEmailDropdownOpen(section, field, i)"
                                      class="absolute z-30 top-full left-0 mt-1 w-full bg-white border rounded-md shadow-md"
                                      style="max-height: 10rem; overflow-y: auto; overflow-x: hidden; overscroll-behavior: contain;"
                                      (wheel)="$event.stopPropagation()"
                                    >
                                      <button
                                        type="button"
                                        *ngFor="let opt of getInternalEmailDropdownOptions(section, field, i)"
                                        (mousedown)="$event.preventDefault(); selectInternalEmailOption(section, field, i, getOptionEmail(opt))"
                                        class="w-full px-3 py-2 text-sm text-left hover:bg-blue-50"
                                      >
                                        {{ getOptionEmail(opt) }}
                                      </button>
                                    </div>
                                  </div>
                                  <div *ngIf="isTableEmailInvalid(section, field, i)" class="mt-1 text-xs text-red-600">
                                    Invalid email
                                  </div>
                                </ng-container>

                                <ng-template #singleTableSelectTpl>
                                  <div class="relative" data-dropdown-scope="true">
                                    <input
                                      type="text"
                                      readonly
                                      name="{{ tableRowName(section, field.key, contact, i) }}"
                                      #c="ngModel"
                                      class="w-full border rounded px-2 pr-8 py-2 text-sm font-light focus:outline-none focus:ring-2 focus:ring-blue-400 bg-white cursor-pointer"
                                      [ngClass]="{ 'border-red-500 ring-1 ring-red-300 bg-red-50': isTableEmailInvalid(section, field, i) || isTableFieldInvalid(section, field, i) }"
                                      [ngModel]="getOptionEmail(getEditContact(section, i, field.key)) || getEditContact(section, i, field.key)"
                                      (click)="onInternalEmailInputFocus(section, field, i)"
                                      (focus)="onInternalEmailInputFocus(section, field, i)"
                                      (blur)="onInternalEmailInputBlur(section, field, i)"
                                      [required]="field.required"
                                    />
                                    <button
                                      type="button"
                                      class="absolute right-2 top-1/2 -translate-y-1/2 text-gray-500"
                                      (mousedown)="$event.preventDefault(); toggleInternalEmailDropdownAll(section, field, i)"
                                      aria-label="Show options"
                                      title="Show options"
                                    >
                                      <svg class="w-10 h-5" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                                        <path d="M7 10h10l-5 6z"></path>
                                      </svg>
                                    </button>

                                    <div
                                      *ngIf="isInternalEmailDropdownOpen(section, field, i)"
                                      class="absolute z-30 top-full left-0 mt-1 w-full bg-white border rounded-md shadow-md"
                                      style="max-height: 10rem; overflow-y: auto; overflow-x: hidden; overscroll-behavior: contain;"
                                      (wheel)="$event.stopPropagation()"
                                    >
                                      <button
                                        type="button"
                                        *ngFor="let opt of getTableFieldOptions(section, field, i)"
                                        (mousedown)="$event.preventDefault(); selectInternalEmailOption(section, field, i, getOptionEmail(opt) || opt)"
                                        class="w-full px-3 py-2 text-sm text-left hover:bg-blue-50"
                                      >
                                        {{ getOptionEmail(opt) || opt }}
                                      </button>
                                    </div>
                                  </div>
                                  <div *ngIf="isTableEmailInvalid(section, field, i)" class="mt-1 text-xs text-red-600">
                                    Invalid email
                                  </div>
                                </ng-template>
                              </ng-container>

                              <ng-template #multiTableSelectTpl>
                                <select
                                  multiple
                                  name="{{ tableRowName(section, field.key, contact, i) }}"
                                  #c="ngModel"
                                  class="w-full border rounded px-3 py-3 text-sm font-light focus:outline-none focus:ring-2 focus:ring-blue-400 bg-white"
                                  [ngModel]="getEditContact(section, i, field.key)"
                                  (ngModelChange)="onTableSelectChange(section, field, i, $event)"
                                  [required]="field.required"
                                >
                                  <option *ngFor="let opt of getTableFieldOptions(section, field, i)" [value]="getOptionEmail(opt)">{{ getOptionEmail(opt) }}</option>
                                </select>
                              </ng-template>
                            </ng-container>

                            <button
                              *ngSwitchCase="'textbox'"
                              type="button"
                              (click)="openNotesModal(section, field, i)"
                              class="inline-flex items-center gap-1.5 w-full border rounded px-2 py-1.5 text-sm text-[#00358E] bg-white hover:bg-blue-50"
                              title="Add or edit notes"
                            >
                              <svg class="w-4 h-4 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                                <path d="M14 2v6h6"></path>
                                <path d="M8 13h8"></path>
                                <path d="M8 17h5"></path>
                              </svg>
                              <span class="truncate">{{ getEditContact(section, i, field.key) ? 'Edit notes' : 'Add notes' }}</span>
                            </button>

                            <textarea
                              *ngSwitchCase="'textarea'"
                              name="{{ tableRowName(section, field.key, contact, i) }}"
                              #c="ngModel"
                              rows="2"
                              class="w-full bg-transparent border-0 p-0 text-sm leading-5 text-[#1F1F1F] focus:outline-none resize-none"
                              [ngModel]="getEditContact(section, i, field.key)"
                              (ngModelChange)="setEditContact(section, i, field.key, $event)"
                              [required]="field.required"
                            ></textarea>

                            <input
                              *ngSwitchDefault
                              type="text"
                              name="{{ tableRowName(section, field.key, contact, i) }}"
                              #c="ngModel"
                              class="w-full bg-transparent border-0 p-0 text-sm leading-5 text-[#1F1F1F] focus:outline-none"
                              [ngClass]="{ 'ring-1 ring-red-500 rounded px-2 py-1 bg-red-50': isTableEmailInvalid(section, field, i) || isTablePhoneInvalid(section, field, i) }"
                              [ngModel]="getEditContact(section, i, field.key)"
                              (ngModelChange)="onTableTextInputChange(section, field, i, $event)"
                              (blur)="onTableInputBlur(section, field, i)"
                              [required]="field.required"
                            />
                            <div *ngIf="isTablePhoneInvalid(section, field, i)" class="mt-1 text-xs text-red-600">
                              Enter valid number
                            </div>
                          </ng-container>
                        </ng-template>
                      </td>
                      <td *ngIf="section.isOnEditMode" class="px-2 py-4 border-b border-r border-[#D5D5D5] text-center align-middle">
                        <button
                          type="button"
                          (click)="confirmRemoveContact(section, i)"
                          class="inline-flex items-center justify-center w-7 h-7 rounded-full text-[#C62828] hover:bg-red-50"
                          aria-label="Remove contact"
                          title="Remove contact"
                        >
                          <span class="text-xl font-bold leading-none">×</span>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div *ngIf="section.isOnEditMode" class="mt-3 flex justify-end">
                  <button
                    type="button"
                    (click)="addContact(section)"
                    [disabled]="!hasAvailableFederationProduct(section)"
                    [ngClass]="{ 'opacity-50 cursor-not-allowed': !hasAvailableFederationProduct(section) }"
                    class="inline-flex items-center gap-2 px-6 py-2 rounded-full bg-[#00358E] text-white text-sm leading-5 font-semibold hover:brightness-95 transition"
                  >
                    <span class="text-base leading-4">+</span>
                    <span>Add new row</span>
                  </button>
                </div>
              </div>
            </ng-template>
          </form>
        </section>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  *ngIf="confirmModalOpen"
  class="fixed inset-0 z-[60] flex items-center justify-center bg-black/40"
  (click)="closeConfirmModal(false)"
>
  <div
    class="bg-white rounded-[8px] shadow-2xl w-[520px] max-w-[90%] p-6"
    (click)="$event.stopPropagation()"
  >
    <p class="text-sm text-[#1F1F1F] leading-6">{{ confirmModalMessage }}</p>
    <div class="mt-6 flex justify-end gap-3">
      <button
        type="button"
        (click)="closeConfirmModal(false)"
        class="px-5 py-2 rounded-full border border-[#D5D5D5] text-sm font-semibold text-[#1F1F1F] hover:bg-gray-50"
      >
        Cancel
      </button>
      <button
        type="button"
        (click)="closeConfirmModal(true)"
        class="px-5 py-2 rounded-full bg-[#00358E] text-sm font-semibold text-white hover:brightness-95"
      >
        Continue
      </button>
    </div>
  </div>
</div>

<!-- Notes Viewer/Editor Modal -->
<div
  *ngIf="notesModalOpen"
  class="fixed inset-0 z-[60] flex items-center justify-center bg-black/40"
  (click)="closeNotesModal()"
>
  <div
    class="bg-white rounded-[8px] shadow-2xl w-[560px] max-w-[92%] p-6"
    (click)="$event.stopPropagation()"
  >
    <div class="flex items-center justify-between mb-4">
      <h3 class="text-base font-semibold text-[#1F1F1F]">{{ notesModalTitle }}</h3>
      <button
        type="button"
        (click)="closeNotesModal()"
        class="text-gray-400 hover:text-gray-600 text-2xl leading-none"
        aria-label="Close"
      >
        ×
      </button>
    </div>

    <ng-container *ngIf="notesModalEditable; else notesReadOnly">
      <textarea
        [(ngModel)]="notesModalValue"
        rows="8"
        class="w-full border rounded-md px-3 py-2 text-sm leading-6 text-[#1F1F1F] focus:outline-none focus:ring-2 focus:ring-blue-400 resize-y"
        placeholder="Enter notes..."
      ></textarea>
      <div class="mt-6 flex justify-end gap-3">
        <button
          type="button"
          (click)="closeNotesModal()"
          class="px-5 py-2 rounded-full border border-[#D5D5D5] text-sm font-semibold text-[#1F1F1F] hover:bg-gray-50"
        >
          Cancel
        </button>
        <button
          type="button"
          (click)="saveNotesModal()"
          class="px-5 py-2 rounded-full bg-[#00358E] text-sm font-semibold text-white hover:brightness-95"
        >
          Save
        </button>
      </div>
    </ng-container>

    <ng-template #notesReadOnly>
      <p
        *ngIf="notesModalValue; else noNotes"
        class="text-sm text-[#1F1F1F] leading-6 whitespace-pre-wrap max-h-[50vh] overflow-y-auto"
      >
        {{ notesModalValue }}
      </p>
      <ng-template #noNotes><p class="text-sm text-gray-400">No notes added.</p></ng-template>
      <div class="mt-6 flex justify-end">
        <button
          type="button"
          (click)="closeNotesModal()"
          class="px-5 py-2 rounded-full bg-[#00358E] text-sm font-semibold text-white hover:brightness-95"
        >
          Close
        </button>
      </div>
    </ng-template>
  </div>
</div>

<!-- Duplicate Emails Warning Modal -->
<div
  *ngIf="duplicateEmailsWarning.length > 0"
  class="fixed inset-0 z-[60] flex items-center justify-center bg-black/40"
  (click)="dismissDuplicateEmailsWarning()"
>
  <div
    class="bg-white rounded-[8px] shadow-2xl w-[520px] max-w-[90%] p-6"
    (click)="$event.stopPropagation()"
  >
    <p class="text-sm font-semibold text-[#1F1F1F] mb-2">Duplicate Emails Detected</p>
    <p class="text-sm text-[#1F1F1F] leading-6 mb-2">The following email(s) already exist and were not added:</p>
    <ul class="list-disc pl-5 mb-4">
      <li *ngFor="let email of duplicateEmailsWarning" class="text-sm text-[#1F1F1F]">{{ email }}</li>
    </ul>
    <div class="flex justify-end">
      <button
        type="button"
        (click)="dismissDuplicateEmailsWarning()"
        class="px-5 py-2 rounded-full bg-[#00358E] text-sm font-semibold text-white hover:brightness-95"
      >
        OK
      </button>
    </div>
  </div>
</div>


<!-- Products Update Modal -->
<div *ngIf="editProductModalOpen" class="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
  <div class="bg-white rounded-[8px] shadow-2xl w-[600px] max-w-[90%] h-auto p-6 pb-0 relative">
    <div class="flex justify-between items-center mb-4">
      <h2 class="text-xl font-medium text-[#00358E]">Edit Product</h2>
      <img src="assets/logos/clientmodal-close-icon.svg" class="cursor-pointer w-[14px] h-[14px]" (click)="closeEditProductModal()" alt="Close">
    </div>

    <form (submit)="$event.preventDefault(); UpdateProducts();" class="space-y-4 pb-[88px]">
      <div class="relative">
        <input
          id="productGroupInput"
          type="text"
          [value]="productGroupSearchTerm"
          name="productGroupInput"
          class="w-full border rounded-md pr-9 px-3 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
          (input)="onProductGroupSearch($any($event.target).value)"
          (focus)="onProductGroupInputFocus()"
          (blur)="onProductGroupInputBlur()"
          placeholder="Search & Add Product Group"
          autocomplete="off"
        />
        <div *ngIf="productGroupDropdownOpen" class="absolute z-10 mt-1 w-full bg-white border rounded-md shadow-md max-h-48 overflow-auto flex flex-col gap-1">
          <div *ngIf="!selectedProductGroupId && filteredSelectableProductGroups.length === 0" class="p-2 text-xs text-gray-500">No available product groups</div>
          <button
            type="button"
            *ngFor="let group of filteredSelectableProductGroups"
            (mousedown)="$event.preventDefault(); $event.stopPropagation(); selectProductGroup(group)"
            class="w-full px-3 py-2 text-xs hover:bg-blue-50 text-left"
          >
            {{ group.groupName }}
          </button>
        </div>
      </div>

      <div class="flex items-start gap-3">
        <div class="relative flex-1">
          <input
            id="productInput"
            type="text"
            [value]="productSearchTerm"
            (input)="onProductSearch($any($event.target).value)"
            (focus)="onProductInputFocus()"
            (blur)="onProductInputBlur()"
            [disabled]="!canSelectProducts"
            class="w-full border rounded-md pr-9 px-3 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
            placeholder="Search & Add Products"
            autocomplete="off"
          />
          <div *ngIf="productDropdownOpen && canSelectProducts" class="absolute z-10 mt-1 w-full bg-white border rounded-md shadow-md max-h-48 overflow-auto flex flex-col gap-1">
            <button
              type="button"
              *ngFor="let product of filteredSelectableProducts"
              (mousedown)="$event.preventDefault(); $event.stopPropagation(); addProductToSelectedGroup(product)"
              class="w-full px-3 py-2 text-xs hover:bg-blue-50 flex items-center justify-between"
            >
              <span>{{ product.productName }}</span>
              <span class="text-blue-500">+</span>
            </button>
          </div>
        </div>

        <button
          type="button"
          (click)="resetSelectedProductGroup()"
          [disabled]="!selectedProductGroupId"
          class="h-[40px] min-w-[52px] px-6 rounded-full bg-[#00358E] text-white text-2xl leading-none disabled:opacity-60 disabled:cursor-not-allowed"
          aria-label="Select another product group"
          title="Select another product group"
        >
          +
        </button>
      </div>

      <div class="space-y-3 max-h-[260px] overflow-y-auto pr-2">
        <div *ngIf="displayedProductGroups.length === 0" class="text-sm text-gray-500">
          No products associated.
        </div>
        <div *ngFor="let group of displayedProductGroups" class="border rounded-md p-3">
          <div class="flex flex-wrap gap-2">
            <span class="flex items-center bg-[#2A7DE1] text-white text-sm font-medium px-4 py-2 rounded-full border border-blue-200">
              {{ group.groupName }}
              <button
                type="button"
                (click)="removeAssociatedProductGroup(group.groupId)"
                class="text-blue-700 hover:text-red-600 ml-2 font-bold"
                title="Remove product group"
              >
                ✕
              </button>
            </span>

            <span
              *ngFor="let product of group.products"
              class="flex items-center border-[#1D65BE] border-[1px] text-[#00358E] text-sm font-medium pl-4 pr-2 py-2 rounded-full bg-white"
            >
              {{ product.productName }}
              <span class="relative ml-2" data-status-dropdown>
                <button
                  type="button"
                  (click)="toggleProductStatusDropdown(product.productId)"
                  class="inline-flex items-center gap-1.5 px-3 py-0.5 text-xs rounded-full border cursor-pointer"
                  [ngClass]="getStatusClass(product.productStatus)"
                  title="Change status"
                >
                <span class="status-dot inline-block w-2 h-2 rounded-full"></span>
                {{ product.productStatus || 'No Status' }}
                <svg class="w-3 h-3 ml-0.5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M6 9l6 6 6-6"/></svg>
              </button>
              <div
                *ngIf="openProductStatusDropdown === product.productId"
                class="absolute top-full left-0 mt-1 z-[100] bg-white border border-gray-200 rounded-xl shadow-lg min-w-[140px] py-2"
              >
                <button
                  type="button"
                  *ngFor="let option of statusOptions"
                  (mousedown)="$event.preventDefault(); setProductStatus(group.groupId, product.productId, option)"
                  class="w-full px-4 py-1 text-sm text-left flex items-center gap-2 hover:bg-gray-50"
                  [ngStyle]="product.productStatus === option && option === 'Inactive' ? {'background-color': '#FEF2F2'} : {}"
                >
                  <span class="status-dot inline-block w-2.5 h-2.5 rounded-full"
                    [ngClass]="getStatusClass(option)"></span>
                  <span class="flex-1">{{ option }}</span>
                  <svg *ngIf="product.productStatus === option" class="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><path d="M5 13l4 4L19 7"/></svg>
                </button>
              </div>
              </span>
              <button
                type="button"
                (click)="removeAssociatedProduct(group.groupId, product.productId)"
                class="text-[#00358E] hover:text-red-600 ml-1 font-bold"
                title="Remove product"
              >
                ✕
              </button>
            </span>
          </div>
        </div>
      </div>

      <div *ngIf="creationError" class="text-sm text-red-600">{{ creationError }}</div>

      <div class="absolute bottom-0 left-0 right-0 h-[72px] flex justify-end gap-8 bg-[#00358E] px-6 rounded-b-[8px]">
        <button type="button" (click)="closeEditProductModal()" class="text-base text-white hover:text-gray-200" [disabled]="isCreatingClient">Cancel</button>
        <button type="submit" [disabled]="!canUpdateProducts()" class="py-3 px-6 my-4 text-sm rounded-[44px] font-medium text-[#00358E] bg-white disabled:opacity-60 hover:bg-gray-200 disabled:cursor-not-allowed">
          <ng-container *ngIf="!isCreatingClient; else creatingSpinner">Update Products</ng-container>
          <ng-template #creatingSpinner>
            <span class="flex items-center gap-2">
              <span class="inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
              Updating...
            </span>
          </ng-template>
        </button>
      </div>
    </form>
  </div>
</div>